import { render, staticRenderFns } from "./CardIframeCustom.vue?vue&type=template&id=9b28bb5a&scoped=true&"
import script from "./CardIframeCustom.vue?vue&type=script&lang=js&"
export * from "./CardIframeCustom.vue?vue&type=script&lang=js&"
import style0 from "./CardIframeCustom.vue?vue&type=style&index=0&id=9b28bb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b28bb5a",
  null
  
)

export default component.exports